// ============================================================
// 初回登録フロー刷新（bag-first）のビルド時フラグ。
//
// 「まず専用バッグを無料でお届け → 到着後にお客様がアプリから集荷を依頼」という
// 新しい初回動線のUIを、ビルド時の環境変数で丸ごと出し分けるためのもの。
//
//   REACT_APP_BAG_FIRST=1 npm run build   → 新フローのUI
//   （未設定でビルド）                      → 従来のUI（現行本番と同一）
//
// サーバ側にも同じ意味のフラグ（app_settings.bag_first_enabled）があり、
// 商品の出し分け・注文の状態遷移はそちらで制御される。9/1の切替は
// 「D1のフラグを立てる」＋「この環境変数を付けてビルドしたものを配信する」の2つ。
// 片方だけ有効でも壊れないようにしてある（UIだけONでも、サーバがbag_statusを
// 返さないため新UIの進行表示は出ない）。詳細は docs/bag-first-cutover.md 参照。
// ============================================================
export const BAG_FIRST = process.env.REACT_APP_BAG_FIRST === '1';

// ------------------------------------------------------------
// bag-first注文の「いまどの段階か」を1か所で判定するヘルパー（2026-09-03）。
// ホーム(Home.jsx)と注文詳細([id].jsx)で同じ判定・同じ文言・同じ遷移になるようにする。
//
//   bagFirstStage(order) → '' | 'delivering' | 'arrived'
//     otype=1 かつ bag_status が delivering/arrived のときだけ値を返す。
//     requested 以降は従来の otype ベースの表示に任せるため '' を返す。
//   findBagFirstOrder(orders) → 進行中一覧から bag-first で止まっている注文を1件返す
//   bagRedeliverNeeded(order) → お届け中のまま配送が canceled/returned で戻った（再依頼が必要）
//   BAG_FIRST_TEXT → 段階ごとの見出し・CTA文言
// ------------------------------------------------------------
export function bagFirstStage(order) {
  if (!BAG_FIRST || !order) return '';
  if (Number(order.otype) !== 1) return '';
  const s = String(order.bag_status || '');
  return (s === 'delivering' || s === 'arrived') ? s : '';
}

export function findBagFirstOrder(orders) {
  if (!BAG_FIRST || !Array.isArray(orders)) return undefined;
  return orders.find((o) => bagFirstStage(o) !== '');
}

export function bagRedeliverNeeded(order) {
  return bagFirstStage(order) === 'delivering'
    && ['canceled', 'returned'].includes(String(order.delivery_status || ''));
}

export const BAG_FIRST_TEXT = {
  delivering: {
    title: '専用バッグをお届け中です',
    lead: 'バッグが届いたら、依頼品(3点まで)を入れて集荷を依頼してください',
    cta: '集荷を依頼する(バッグ到着後に押せます)',
  },
  arrived: {
    title: '専用バッグが届きました',
    lead: '依頼品(3点まで)をバッグに入れて、下のボタンから集荷を依頼してください',
    cta: '集荷を依頼する',
  },
  redeliver: {
    cta: 'バッグお届けを再依頼',
  },
};

// 依頼（集荷・バッグの再お届け）が通ったあと、進行中の注文の一覧のその注文を、API が返した最新の注文に置き換える。
// 置き換えずに注文の画面へ移ると、古い bag_status='arrived' のまま「集荷を依頼する」がまた出て、押すと E033 で断られた
// （2026-11-03〜04 注文1559・1560。LP エラー 0f7dfc22）。
export function replaceOrder(orders, fresh) {
  if (!fresh || !Array.isArray(orders)) return orders;
  return orders.map((o) => (String(o.id) === String(fresh.id) ? fresh : o));
}
